import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { TableData } from '@anytag/shared-types';
import { useTableMaxHeight } from '@anytag/shared-hooks';
import { SelectionBar, Button, TableV2 } from '@anytag/shared-atoms';
import { YoutubeCMSChannel } from '../types';
import { useYoutubeCMSChannelsTable } from './hooks';
import { YoutubeCMSChannelRevenueFormValues } from './types';

export type TemplateProps = TableData<YoutubeCMSChannel> &
  Pick<Parameters<typeof useYoutubeCMSChannelsTable>[0], 'type' | 'modifiable'>;

export const Template = ({ type, loading, data = [], modifiable }: TemplateProps) => {
  const { t } = useTranslation();
  const { offsetRef, defaultTableMaxHeight } = useTableMaxHeight();
  const { columns } = useYoutubeCMSChannelsTable({ type, modifiable });
  const {
    formState: { isDirty, isSubmitting }
  } = useFormContext<YoutubeCMSChannelRevenueFormValues>();

  return (
    <div className="relative">
      <TableV2
        data={data}
        ref={offsetRef}
        rowHeight="64px"
        loading={loading}
        columns={columns}
        maxHeight={defaultTableMaxHeight}
        noTopBorderRadius
        stickyHeader
      />

      {isDirty && !loading ? (
        <SelectionBar>
          <Button
            variant="solid"
            type="submit"
            id="skipOutsideClick"
            title={t('Button.Save')}
            className="ml-auto px-4"
            loading={{ status: isSubmitting, title: t('Button.Saving') }}
          />
        </SelectionBar>
      ) : null}
    </div>
  );
};
